import { render, staticRenderFns } from "./common-info.vue?vue&type=template&id=32b9d0fa"
import script from "./common-info.vue?vue&type=script&lang=js"
export * from "./common-info.vue?vue&type=script&lang=js"
import style0 from "./common-info.vue?vue&type=style&index=0&id=32b9d0fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports